var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8306 8.89891C11.5483 8.89891 11.3206 8.81239 11.1475 8.63934C10.9745 8.4572 10.888 8.22495 10.888 7.94262C10.888 7.66029 10.9745 7.43261 11.1475 7.25956C11.3206 7.08652 11.5483 7 11.8306 7C12.1038 7 12.3315 7.08652 12.5137 7.25956C12.6958 7.43261 12.7869 7.66029 12.7869 7.94262C12.7869 8.22495 12.6958 8.4572 12.5137 8.63934C12.3315 8.81239 12.1038 8.89891 11.8306 8.89891ZM10.1777 10.4789C10.0761 10.466 10 10.3795 10 10.2771C10 10.1648 10.0911 10.0738 10.2034 10.0738H11.3115C12.0358 10.0738 12.623 10.6609 12.623 11.3852V15.8525C12.623 16.1621 12.6366 16.3488 12.6639 16.4126C12.6913 16.4672 12.7778 16.5036 12.9235 16.5219L13.4972 16.5949C13.5987 16.6078 13.6749 16.6942 13.6749 16.7966C13.6749 16.9089 13.5838 17 13.4715 17H10.2034C10.0911 17 10 16.9089 10 16.7966C10 16.6942 10.0761 16.6078 10.1777 16.5949L10.7514 16.5219C10.8971 16.5036 10.9836 16.4672 11.0109 16.4126C11.0383 16.3488 11.0519 16.1621 11.0519 15.8525V11.2213C11.0519 10.9117 11.0383 10.7295 11.0109 10.6749C10.9836 10.6111 10.8971 10.5701 10.7514 10.5519L10.1777 10.4789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.d1acd47fab56df483b8bbe54b98e5dbd.svg";
export { ForwardRef as ReactComponent };